import React, { useState, useEffect, useRef } from "react";
import { request } from "../../utils/axios-utils";
import { useQuery } from "react-query";
import { useParams, useLocation } from "react-router-dom";
import useWindowDimensions from "../../hooks/useWindowDimensions";
import RightArrowButton from "../../components/RightArrowButton/RightArrowButton";
import parse from "html-react-parser";
import BreadCrumb from "../../components/BreadCrumb/BreadCrumb";

import {
  linkedingrey,
  instagrey,
  fbgrey,
  youtubegrey,
  pinterestgrey,
  twiitergrey,
} from "../../images";
import "./OurBrand.scss";
import { brandImageUrl, convertSlugtoString } from "../../helpers/utils";
import Loader from "../../components/Loader/Loader";
import MetaDecorator from "../../components/MetaDecorator/MetaDecorator";

const OurBrand = () => {
  const location = useLocation();
  const boxId = location.state?.boxId;
  const { width } = useWindowDimensions();
  const { brandCategory } = useParams();
  const [bannerDetails, setBannerDetails] = useState(null);
  const [brandDataArr, setBrandDataArr] = useState([]);
  const [br, setbr] = useState([]);
  const imgRef = useRef();
  const parsedUrl = window.location.href
  const segments = parsedUrl.split('/');
  const lastSegment = segments[segments.length - 1];
  const {
    isLoading,
    refetch: refetchBrandDataData,
    isFetching,
  } = useQuery(
    "brand-inner",
    async () => {
      return request({
        url: `/brands/categories/${brandCategory}`,
        method: "get",
      });
    },
    {
      enabled: false,
      onSuccess: (data) => {
        let brandDataObj = {}
        if (lastSegment === 'jk-files-engineering') {
          brandDataObj = {
            "_id": "62dffdcb31855c49188ddfeb",
            "title": "Engineering",
            "title2": "(Tools, Auto and Aerospace)",
            "slug": "Engineering",
            "description": "<p>&lrm;</p>",
            "image": "1659511375549Pithampur (1)-min.png",
            "sort_order": 3,
            "createdAt": "2022-07-26T14:44:27.484Z",
            "updatedAt": "2023-12-08T10:19:48.585Z",
            "__v": 0,
            "brands": [
              {
                "_id": "62e0054d9fe9a117cb3ce9cc",
                "title": "JK Engineering",
                "description": "<p><span style=\"font-weight: 400;\">JK Files &amp; Engineering Limited, a subsidiary of Raymond Ltd, is the world's largest manufacturer of steel files with a presence in 55+ countries. With trusted relationships that are built over the past seven decades, JK Files &amp; Engineering has earned a reputation for offering an expansive and versatile range of custom-made files and tools as per BS, FS, ISI and DIN standards or as specified by customers. The company also has a strong presence in the Asian, African and Latin American regions and is the largest brand in the African market. In addition, it is amongst the known players in the drills segment in India.</span></p>\r\n<p>&nbsp;</p>\r\n<p><span style=\"font-weight: 400;\">JK Files &amp; Engineering is involved in the manufacturing and sale of precision engineered components for tools and hardware such as steel files, drills, hand tools and powerful tool </span><span style=\"font-weight: 400;\">accessories as well as auto components such as ring gears, flexplates and water pump</span></p>\r\n<p><span style=\"font-weight: 400;\">bearings. It has futuristic manufacturing ISO 9001-2015 certified plants in Ratnagiri &amp; Chiplun (Maharashtra), Pithampur (Madhya Pradesh) and Vapi (Gujarat) and is equipped with in-house rolling mills that ensure premium quality as well as easy product availability.&nbsp;</span></p>\r\n<p><span style=\"font-weight: 400;\">&nbsp;</span></p>\r\n<p><span style=\"font-weight: 400;\">The brand &lsquo;JK Superdrive&rsquo; extends JK Files' rich legacy of technological know-how and expertise in manufacturing files and Drills to quality products in Hand Tools and Power Tools categories. The expansive portfolio includes a wide variety of handheld electric-powered and non-powered tools. JK Superdrive has a resilient supply chain and a pan-India distribution network consisting of over 730 active distributors with a retail reach of over 150,000 outlets spanning over 600 towns in India. While JK Superdrive represents domestic markets, Three Files represents JK Files Latin America and African countries, and Sunflower is a leading Files brand in MEA and ASIAN markets.</span></p>\r\n<p><span style=\"font-weight: 400;\">&nbsp;</span></p>\r\n<p><span style=\"font-weight: 400;\">For detailed information and the range of each category, please visit our website.</span></p>",
                "image": "https://api.raymond.in/uploads/brand/1663675211738Jk%20engineering.jpg",
                "website": "https://www.jkfilesandengineering.com/",
                "pintrest": "",
                "facebook": "",
                "linkedin": "",
                "youtube": "",
                "twitter": "",
                "instagram": "",
                "status": 1,
                "brandCategory": "62dffdcb31855c49188ddfeb",
                "sort_order": 1,
                "createdAt": "2022-07-26T15:16:29.513Z",
                "updatedAt": "2023-12-08T10:33:12.825Z",
                "__v": 0
              },
              {
                "_id": "6308c5991d7fb152e7de79ad",
                "title": "Ring Plus Aqua Ltd",
                "description": "<p>In 1984, Raymond forayed into the Automotive Components via Ring Plus Aqua Ltd- a prominent Ring Gear, Water Pump Bearings and Flexplate manufacturer in India. Equipped with state-of-the-art infrastructure and certified with ISO/TS 16949 Quality System, RPAL offers a strong value proposition in the industry. It has a market leadership position in Ring Gears with a volume share of more than 50% in Passenger Vehicles and more than 45% in Commercial Vehicles in India in Fiscal 2021.</p>\r\n<p>With its operation base in Nashik and Corporate Office In Mumbai, RPAL has a long celebrated history with the global auto &amp; non-auto industry. It is the sole domestic manufacturer of flexplates in India and caters to over 25% of the flexplates volume demand for PV domestic production in Fiscal 2021. We focus on producing products that exceed customer expectations with an emphasis on OTIF (On Time In Full), Reliable Quality and cater to the JIT (Just-in-time) needs through our warehouses in Canada, the United States &amp; Germany. RPAL has an annual production capacity of 8.2 million pieces for Ring Gears, 3.9 million pieces for Water Pump Bearings and 0.62 million pieces for Flexplates.</p>",
                "image": "https://api.raymond.in/uploads/brand/1663823147678Ring%20plus%20aqua.jpg",
                "website": "https://ringplusaqua.com",
                "pintrest": "",
                "facebook": "",
                "linkedin": "",
                "youtube": "",
                "twitter": "",
                "instagram": "",
                "status": 1,
                "brandCategory": "62dffdcb31855c49188ddfeb",
                "sort_order": 2,
                "createdAt": "2022-08-26T13:07:37.496Z",
                "updatedAt": "2022-09-22T05:05:47.862Z",
                "__v": 0
              },
              {
                "_id": "6308c5991d7fb152e7de79ad",
                "title": "MPPL",
                "description": "<p>MPPL is an end-to-end solutions provider engaged in process design, engineering, manufacturing, testing, and supply of a variety of precision products and assemblies.They are capable of diverse and critical manufacturing and finishing processes, including machined castings, die castings, machined forgings, bar route machining, plate machining, surface treatment, heat treatment, critical assembly, as well as ancillary activities such as end of line testing, export packing and warehousing, which helps us provide end-to-end solutions for our customer requirements.</p>",
                "image": "https://oneraymond.in/media/MPPL.jpg",
                "website": "https://www.mainiprecisionproducts.com/",
                "pintrest": "",
                "facebook": "",
                "linkedin": "",
                "youtube": "",
                "twitter": "",
                "instagram": "",
                "status": 1,
                "brandCategory": "62dffdcb31855c49188ddfeb",
                "sort_order": 2,
                "createdAt": "2022-08-26T13:07:37.496Z",
                "updatedAt": "2022-09-22T05:05:47.862Z",
                "__v": 0
              }
            ]
          }
          setBrandDataArr(brandDataObj.brands);
        } else {
          brandDataObj = data.data.data;
          setBrandDataArr(brandDataObj.brands);
        }
        if (brandDataObj) {
          setBannerDetails(brandDataObj);

        }
      },
    }
  );





  useEffect(() => {
    if (brandCategory) {
      refetchBrandDataData();
    }
  }, [brandCategory]);
  // useEffect(() => {
  //   if (bannerDetails) {
  //    
  //   }
  // }, [bannerDetails]);

  // useEffect(() => {
  // if (boxId) {
  //   const domBoxId = document.getElementById(boxId);
  //   if (boxId === domBoxId?.id) {
  //     applyScroll(boxId, -50);
  //   }
  // }
  // }, [brandDataArr]);

  const brandList =
    brandDataArr.length > 0
      ? brandDataArr.map(
        (
          {
            title,
            description,
            image,
            website,
            facebook,
            instagram,
            linkedin,
            pintrest,
            twitter,
            youtube,
            _id,
          },
          i
        ) => (
          < div className="col-lg-6 flex_box" key={i} id={_id} >
          
            {width <= 834 ? <div className="mobheading">{title}</div> : null}
            <div className="zoomout">
              <img
                src={(lastSegment === 'jk-files-engineering')?image:brandImageUrl + image}
                alt="raymond Brand img"
                className="mainimg"
                loading="lazy"
                width={1544}
                height={1074}
              />
            </div>
            <div className="text_container">
              {width > 834 ? <div className="heading">{title}</div> : null}
              <div className="desc">{parse(description)}</div>
            </div>
            <div className="cta_social">
              {website && (
                <div
                  className={`cta_wrapper ${website &&
                    (linkedin ||
                      instagram ||
                      facebook ||
                      pintrest ||
                      twitter ||
                      youtube)
                    ? "active"
                    : ""
                    }`}
                >
                  <RightArrowButton
                    ctaText="View Website"
                    anchorCta
                    anchorLink={website}
                  />
                </div>
              )}
              <div className="social_box">
                {linkedin && (
                  <a href={linkedin} target="_blank" rel="noreferrer">
                    <img
                      className="icon"
                      src={linkedingrey}
                      alt="social"
                      loading="lazy"
                    />
                  </a>
                )}
                {instagram && (
                  <a href={instagram} target="_blank" rel="noreferrer">
                    <img
                      className="icon"
                      src={instagrey}
                      alt="social"
                      loading="lazy"
                    />
                  </a>
                )}
                {facebook && (
                  <a href={facebook} target="_blank" rel="noreferrer">
                    <img
                      className="icon"
                      src={fbgrey}
                      alt="social"
                      loading="lazy"
                    />
                  </a>
                )}
                {pintrest && (
                  <a href={pintrest} target="_blank" rel="noreferrer">
                    <img
                      className="icon"
                      src={twiitergrey}
                      alt="social"
                      loading="lazy"
                    />
                  </a>
                )}
                {twitter && (
                  <a href={twitter} target="_blank" rel="noreferrer">
                    <img
                      className="icon"
                      src={youtubegrey}
                      alt="social"
                      loading="lazy"
                    />
                  </a>
                )}
                {youtube && (
                  <a href={youtube} target="_blank" rel="noreferrer">
                    <img
                      className="icon"
                      src={pinterestgrey}
                      alt="social"
                      loading="lazy"
                    />
                  </a>
                )}
              </div>
            </div>
          </div >
        )
      )
      : null;

  useEffect(() => {
    window.scrollTo(0, 0);
  });
  if (isLoading || isFetching) {
    return <Loader />;
  }

  return (
    <>
      <MetaDecorator metaTitle="Welcome to Raymond | Our Brand" />
      <section className="Brand_sec1" data-aos="fade-in">
        {/* bannerDetails use this directly */}
        <div className="my_container">
          {/* {bannerList} */}
          {bannerDetails && (
            <div className="row">
              <div className="col-lg-8">
                {width <= 834 ? (
                  <div className="text_container">
                    <BreadCrumb
                      linkTwoText="our businesses"
                      linkTwoDisabled
                      linkThreeText={convertSlugtoString(bannerDetails.slug)}
                      linkThreeDisabled
                    />
                    <div className="heading">{bannerDetails.title}</div>

                    {width > 600 ? (
                      <div className="desc">
                        {parse(bannerDetails.description)}
                      </div>
                    ) : null}
                  </div>
                ) : null}
                <img
                  src={brandImageUrl + bannerDetails.image}
                  alt="raymond Brand img"
                  className="mainimg"
                  width={1038}
                  height={659}
                  ref={imgRef}
                />
                {width <= 600 ? (
                  <div className="desc">{parse(bannerDetails.description)}</div>
                ) : null}
              </div>
              <div className="col-lg-4 flex_box">
                {width > 834 ? (
                  <div className="text_container">
                    {/* <div className="breadcrumb">breadcrumb</div> */}
                    <BreadCrumb
                      linkTwoText="our businesses"
                      linkTwoDisabled
                      linkThreeText={convertSlugtoString(bannerDetails.slug)}
                      linkThreeDisabled
                    />
                    <div className="heading">{bannerDetails.title}</div>
                    <span className="subheading">{bannerDetails.title2}</span>
                    <div className="desc">
                      {parse(bannerDetails.description)}
                    </div>
                  </div>
                ) : null}
              </div>
            </div>
          )}
        </div>
      </section>

      <section className="Brand_sec2" data-aos="fade-in">
        <div className="my_container">
          <div className="row">{brandList}</div>
        </div>
      </section>
    </>
  );
};

export default OurBrand;
